import { useTranslation } from 'next-i18next'
import { FC } from 'react'

import Input from '~/bootcamp/Activities/components/Input'
import { Breakpoint, useCheckBreakpoint } from '~/utils'

import styles from './style.module.css'

interface IProps {
  names: string[]
  values: string[]
  onChange: (value: string, name: string) => void
  onEnter?: () => void
}

const LatticeCell: FC<IProps> = ({ names, onChange, values, onEnter }) => {
  const { t } = useTranslation('generics')
  const [field1, field2] = names
  const [field1Value, field2Value] = values
  const isMobile = useCheckBreakpoint({ lt: Breakpoint.LG })

  const handleOnChange = (value: string, name: string): void => {
    onChange(value, name)
  }

  return (
    <div className={`overflow-hidden relative border-theory-red-light ${styles.cellWrap}`}>
      <label
        className={`border-2 h-32 w-full absolute rotate-45 origin-top-right flex justify-end items-center bg-purple-light ${styles.bordered} ${styles.field1} ${styles.top}`}
        htmlFor={field1}
      >
        <Input
          aria-label={t('ariaLabelButtons.insertValue')}
          autoComplete="off"
          className={`-rotate-45 text-center sm:text-xl lg:text-2xl font-bold bg-purple-light text-purple ${styles.inputFields}`}
          id={field1}
          inputSize={(isMobile && 'xs') || undefined}
          isSmall
          maxDigits={1}
          name={field1}
          onChange={handleOnChange}
          onEnter={onEnter}
          type="text"
          value={field1Value || ''}
        />
      </label>

      <label
        className={`border-2 h-32 w-full absolute rotate-45 flex justify-start items-center bg-purple-light ${styles.bordered} ${styles.field2} ${styles.bottom}`}
        htmlFor={field2}
      >
        <Input
          aria-label={t('ariaLabelButtons.insertValue')}
          autoComplete="off"
          className={`-rotate-45 text-cente focus:border-none sm:text-xl lg:text-2xl font-bold bg-purple-light text-purple ${styles.inputFields}`}
          id={field2}
          inputSize={(isMobile && 'xs') || undefined}
          isSmall
          maxDigits={1}
          name={field2}
          onChange={handleOnChange}
          onEnter={onEnter}
          type="text"
          value={field2Value || ''}
        />
      </label>
    </div>
  )
}

export { LatticeCell }
